import React, { Fragment, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import {
  validateCharacters,
  validateEmpty,
} from "../../../../shared/helper/validations";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

export default function EdgeMedia({ ...props }) {
  const [media, setMedia] = React.useState([]);
  const [dirty, setDirty] = React.useState([]);
  const [errors, setErrors] = React.useState([]);
  const { t } = useTranslation("edge");

  useEffect(() => {
    if (props.media) {
      setMedia([props.media]);
      const initialDirty = [true];
      setDirty(initialDirty);
      validate([props.media], initialDirty);
    } else {
      setMedia([{}]);
      setDirty([false]);
      setErrors([""]);
    }
  }, []);

  async function updateName(e, index) {
    let current = [...media];
    current[index].name = e.target.value;
    setMedia(current);

    let currentDirty = [...dirty];
    currentDirty[index] = true;
    setDirty(currentDirty);

    validate(current, currentDirty);
  }

  function validate(currentMedia, currentDirty) {
    let valid = true;
    let currentErrors = currentDirty.map((isDirty, index) => {
      const mediaItem = currentMedia[index];
      let error = "";

      if (mediaItem.name != undefined && !validateCharacters(mediaItem.name)) {
        error = t("validateNameInvalid");
        valid = false;
      }

      if (!validateEmpty(mediaItem.name)) {
        error = t("validateNameEmpty");
        valid = false;
      }

      return error;
    });

    setErrors(currentErrors);
    props.mediaUpdate(currentMedia[0], valid);
  }

  return (
    <Fragment>
      <div>
        <h3 className="media-title">{t("mediaTitle")}</h3>
        {media.map((item, index) => (
          <div key={index} className="media">
            <Tooltip
              title={props.userPermissions ? "" : t("noPermissionTooltip")}
              placement="left">
              <TextField
                className="media-name"
                label={t("mediaName")}
                variant="standard"
                multiline
                required
                disabled={!props.userPermissions}
                fullWidth
                value={item.name || ""}
                onChange={(e) => updateName(e, index)}
                error={dirty[index] && Boolean(errors[index])}
                helperText={dirty[index] ? errors[index] : ""}
              />
            </Tooltip>
          </div>
        ))}
      </div>
    </Fragment>
  );
}

EdgeMedia.propTypes = {
  media: PropTypes.object,
  mediaUpdate: PropTypes.func.isRequired,
  userPermissions: PropTypes.bool.isRequired,
};
